var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2501 9.7715L3.0501 6.5715C2.81424 6.34391 2.49843 6.21807 2.17068 6.22107C1.84294 6.22407 1.52948 6.35568 1.29783 6.58755C1.06618 6.81942 0.934864 7.133 0.932171 7.46075C0.929479 7.7885 1.05562 8.10419 1.28343 8.33984L5.4501 12.5065C5.57289 12.6292 5.71989 12.725 5.88173 12.7878C6.04358 12.8505 6.21672 12.8789 6.39013 12.871C6.56354 12.8632 6.73342 12.8193 6.88894 12.7422C7.04446 12.6651 7.18222 12.5565 7.29343 12.4232L15.6268 2.42317C15.8296 2.16754 15.9244 1.84272 15.891 1.51812C15.8575 1.19351 15.6985 0.894848 15.4478 0.68594C15.1971 0.477032 14.8747 0.374439 14.5493 0.400081C14.224 0.425723 13.9216 0.577566 13.7068 0.82317L6.2501 9.7715Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.002ffdab5d28a854db7bafc3ee602396.svg";
export { ForwardRef as ReactComponent };